import Button from '@mui/material/Button';
import type React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import type { AssetForm } from '../../../store/forms';
import { SaveAssetJobsSelector } from '../../../store/slices/saveAssetJobsState/SaveAssetJobsState';
import useAppUtils from '../../../utils/appUtils';

interface IProps {
  filesChange: (files: File[]) => void;
  assetForm: AssetForm;
  openDialog: (event) => void;
}
const IngestWidget = ({ filesChange, assetForm, openDialog }: IProps) => {
  const fileInput = useRef<HTMLInputElement | null>(null);
  const [isDragOverActive, setDragOverActive] = useState(false);
  const [ingestFile, setIngestFile] = useState(assetForm.ingestFile);
  const [ingestFiles, setIngestFiles] = useState(assetForm.ingestFiles);
  const [isMultiple, setIsMultiple] = useState(false);
  const { jobs } = useSelector(SaveAssetJobsSelector);
  const { confirm, alert } = useAppUtils();

  const onBrowseButtonClick = () => {
    // `current` points to the mounted file input element
    if (fileInput && fileInput.current) {
      fileInput.current.click();
    }
  };

  const onDragEnter = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault(); // NOTE: this is required otherwise drag and drop won't work!
    event.stopPropagation();
    setDragOverActive(true);
  };
  const onDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault(); // NOTE: this is required otherwise drag and drop won't work!
    event.stopPropagation();
    setDragOverActive(true);
  };

  const onDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault(); // NOTE: this is required otherwise drag and drop won't work!
    event.stopPropagation();
    setDragOverActive(true);
  };
  const onDragEnd = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault(); // NOTE: this is required otherwise drag and drop won't work!
    event.stopPropagation();
    setDragOverActive(false);
  };
  const onFileDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault(); // NOTE: this is required otherwise drag and drop won't work!
    event.stopPropagation();
    setDragOverActive(false);
    const { files } = event.dataTransfer;
    processFileChange(files);
  };

  const processFileChange = (fileList: FileList) => {
    // console.log('processFileChange', { fileList });
    if (fileList.length === 0) {
      setIsMultiple(false);
      return;
    }

    // only supporting single file upload...multiple files are possible with the drag and drop, so just take the first file...
    if (fileList.length === 1) {
      setIsMultiple(false);
    } else {
      setIsMultiple(true);
    }
    setIngestFiles(fileList);
    filesChange(fileList);
    if (fileInput && fileInput.current) fileInput.current.value = '';
  };

  useEffect(() => {
    // console.log('assetForm---', assetForm.ingestFiles);
    setIngestFiles(assetForm.ingestFiles);
  }, [assetForm]);

  return (
    <div
      id="ingest-widget"
      className="ingestWidgetClasses"
      onDragOver={onDragOver}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      onDragEnd={onDragEnd}
      onDrop={onFileDrop}
      test-id="ingest-widget"
    >
      <form encType="multipart/form-data">
        <div className="ingest-drop">
          {/* <span className="fa fa-cloud-upload"></span> */}
          <i className="icon material-icons">backup</i>
          <p>Drag and Drop File here</p>
        </div>
        <p>or</p>
        <p>Choose file to upload</p>
        <div className="file-section">
          <input
            className="file-input"
            type="file"
            id="file"
            ref={fileInput}
            onChange={(e) => processFileChange(e.target.files)}
            multiple
          />
          <Button
            variant="contained"
            style={{
              // backgroundColor: '#0db080',
              fontSize: '13px',
              marginTop: '5px',
            }}
            size="small"
            className="browse-button"
            color="primary"
            onClick={onBrowseButtonClick}
          >
            BROWSE
          </Button>
        </div>
        {/* {ingestFiles.length === 1 && <label className="file-name">{clientUtils.shortenFileName(ingestFiles[0].name, 32)}</label>} */}
        {ingestFiles.length > 0 && (
          <a className="file-link" onClick={openDialog} style={{ cursor: 'pointer' }}>
            {ingestFiles.length} Files Selected
          </a>
        )}
        {assetForm.errors && (
          <div className="text-danger" test-id="ingest-file-error-message">
            {assetForm.errors.message('ingestFile')}
          </div>
        )}
      </form>
    </div>
  );
};

export default IngestWidget;
